<template>
  <div class="home-page">
    <div class="home-placeholder">
      <h1>Inicio</h1>
      <p>Sección en proceso.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
};
</script>

<style scoped>
.home-page {
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 120px);
}

.home-placeholder {
  width: min(640px, 100%);
  text-align: center;
  border: 1px solid #e5e7eb;
  border-radius: 14px;
  padding: 40px 24px;
  background: #ffffff;
}

.home-placeholder h1 {
  margin: 0;
  font-size: 28px;
  color: #111827;
}

.home-placeholder p {
  margin: 10px 0 0;
  color: #6b7280;
  font-size: 16px;
}
</style>
